// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container-stepper[data-v-53fe8b8d] {\r\n  min-height: 75vh;\r\n  padding: 1rem 2.5rem;\r\n  width: 100% !important;\r\n  position: relative;\n}\n@media screen and (max-width: 1100px) {\n.container-stepper[data-v-53fe8b8d] {\r\n    height: auto;\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
